import React, { useEffect, useState } from "react";
import { Button, Menu, MenuItem, Tooltip } from "@mui/material";
import { MULTI_LANGUAGE, MULTI_LANGUAGE_NAMES } from "@/utils/Constant";
import i18n from "@/Misc/i18nConfig";
import { TranslateOutlined, ArrowDropDownOutlined } from "@mui/icons-material";
import { useAppSelector } from "@/app/hooks";
import { setLanguage } from "@/features/Global/slice";
import { useDispatch } from "react-redux";

const LanguageSelector: React.FC = () => {
  const { language } = useAppSelector((state) => state.appGlobal);
  const dispatch = useDispatch();

  const [lang, setLang] = React.useState<string>(
    language || MULTI_LANGUAGE.ENG
  );
  useEffect(() => {
    if (language) {
      setLang(language);
    }
  }, [language]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleLanguageChange = (
    selectedLanguage: keyof typeof MULTI_LANGUAGE_NAMES
  ) => {
    // setLang(selectedLanguage);
    dispatch(setLanguage(selectedLanguage));
    // localStorage.setItem("language", selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Select Language">
        <Button
          startIcon={<TranslateOutlined />}
          endIcon={<ArrowDropDownOutlined />}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ color: "white", bgcolor: "transparent" }}
          id="snr-ai-LanguageSelector-selectLanguageButton"
        >
          {MULTI_LANGUAGE_NAMES[lang as keyof typeof MULTI_LANGUAGE_NAMES]}
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {Object.entries(MULTI_LANGUAGE_NAMES).map(([key, name]) => (
          <MenuItem
            key={key}
            selected={language === key}
            onClick={() =>
              handleLanguageChange(key as keyof typeof MULTI_LANGUAGE_NAMES)
            }
            id={`snr-ai-LanguageSelector-menuItem-${key}`}
          >
            {name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;